import React from "react";
import type { ModalContent } from "./Modal";

export interface ModalContextType {
  openModal: (content?: ModalContent | false) => void;
  closeModal: () => void;
  isOpen: boolean;
  modalContent: ModalContent | false | null;
  hideCloseButton: () => void;
  showCloseButton: boolean;
}

export const ModalContext = React.createContext<ModalContextType>({
  openModal: () => {},
  closeModal: () => {},
  isOpen: false,
  modalContent: null,
  hideCloseButton: () => {},
  showCloseButton: true,
});
